module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
// module id = 0
// module chunks = 0